module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-12.66f31878.png";